import React from 'react';
import RecipientsListDF from '../components/SimulatorsComponents/DefualtSimulators/RecipientsListDF';

const Sim_F02_RequestPaymentRecipientsList = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <RecipientsListDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);
export default Sim_F02_RequestPaymentRecipientsList;
